module.exports = __webpack_public_path__ + "static/ladies-on-bridge-789349e68d9b2c28eeff9294cb72863c.jpg";